import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { refreshAuth } from 'Redux/ducks/auth';
import CartNotifications from 'Components/Account/ContactPreferences/CartNotifications';
import EmailNewsletter from 'Components/Account/ContactPreferences/EmailNewsletter';
import ExtensionInstall from 'Components/Account/ContactPreferences/ExtensionInstall';
import KeyRedeemReminders from 'Components/Account/ContactPreferences/KeyRedeemReminders';
import PreferenceCard from 'Components/Account/ContactPreferences/PreferenceCard';
import ReviewReminders from 'Components/Account/ContactPreferences/ReviewReminders';
import UserReviewReminders from 'Components/Account/ContactPreferences/UserReviewReminders';
import WishlistNotifications from 'Components/Account/ContactPreferences/WishlistNotifications';

function ContactPreferences({
  emailNewsletter,
  refreshAuthProp,
}) {
  return (
    <section className="account-content">
      <h1>
        <FormattedMessage id="account-contact-preferences.heading" defaultMessage="Contact Preferences" />
      </h1>
      <div className="account-table login-and-security">
        <EmailNewsletter
          emailNewsletter={emailNewsletter}
          refreshAuth={refreshAuthProp}
        />
        <WishlistNotifications />
        <CartNotifications />
        <ReviewReminders />
        <UserReviewReminders />
        <KeyRedeemReminders />
        <ExtensionInstall />
        <PreferenceCard
          title="Post Purchase Advert Preference"
          actionText="Adverts"
        />
      </div>
    </section>
  );
}

ContactPreferences.propTypes = {
  emailNewsletter: PropTypes.bool,
  refreshAuthProp: PropTypes.func.isRequired,
};

ContactPreferences.defaultProps = {
  emailNewsletter: false,
};

const mapStateToProps = ({
  auth: {
    email_newsletter: emailNewsletter,
  },
}) => ({
  emailNewsletter,
});

export default connect(mapStateToProps, { refreshAuthProp: refreshAuth })(ContactPreferences);
